import { yupResolver } from '@hookform/resolvers/yup';
import { boolean, object } from 'yup';

import { AllocationMode } from './constants/allocationMode';

type DynamicFieldSuffix = 'A' | 'B' | 'C';

type DynamicFormFields = {
  [K in DynamicFieldSuffix as `clients${K}`]: number[];
} & {
  [K in DynamicFieldSuffix as `groups${K}`]: number[];
} & {
  [K in DynamicFieldSuffix as `teamId${K}`]: number;
};

export interface IFormDynamicValues extends DynamicFormFields {
  includeWeekends: boolean;
  dateRange: [Date, Date];
  allocationMode: AllocationMode.BY_CLIENT;
  teamId?: number;
}

const validationSchema = object().shape({
  includeWeekends: boolean(),
});

export default yupResolver(validationSchema);
